import { useTranslation } from 'next-i18next'

export default function TableOfContents({
  items,
}: {
  items: { id: string; text: string }[]
}) {
  const { t } = useTranslation('blog')

  if (!items.length) return null

  return (
    <div className="text-sm">
      <p className="mb-2 font-semibold">{t('tableOfContentTitle')}</p>
      <ul className="space-y-1">
        {items.map((h) => (
          <li key={h.id}>
            <a href={`#${h.id}`} className="text-blue-600 hover:underline">
              {h.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
